import React, { useState, useEffect } from 'react';
import { X, Save, Loader2, Tag } from 'lucide-react';
import styles from './AddExpenseCategoryDrawer.module.css';
import api from '../../api/axios';
import toast from 'react-hot-toast';

const AddExpenseCategoryDrawer = ({ isOpen, onClose, onSuccess, category = null }) => {
  const [categoryName, setCategoryName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (category) {
      setCategoryName(category.category_name || '');
    } else {
      setCategoryName('');
    }
  }, [category, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!categoryName.trim()) {
      toast.error('Category name is required');
      return;
    }

    setIsSubmitting(true);
    try {
      let response;
      if (category) {
        // Update existing category
        response = await api.put(`/expense-categories/${category.id}`, {
          category_name: categoryName
        });
      } else {
        // Create new category
        response = await api.post('/expense-categories', {
          category_name: categoryName
        });
      }

      if (response.data.success) {
        toast.success(response.data.message || 'Success');
        onSuccess();
        onClose();
        setCategoryName('');
      }
    } catch (error) {
      console.error('Error saving expense category:', error);
      toast.error(error.response?.data?.message || 'Failed to save expense category');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div 
        className={`${styles['drawer-overlay']} ${isOpen ? styles['open'] : ''}`} 
        onClick={onClose}
      />
      <div className={`${styles['drawer']} ${isOpen ? styles['open'] : ''}`}>
        <div className={styles['drawer-header']}>
          <h2>{category ? 'Edit Category' : 'Add New Category'}</h2>
          <button className={styles['close-btn']} onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <form className={styles['drawer-content']} onSubmit={handleSubmit}>
          <div className={styles['form-group']}>
            <label>Category Name *</label>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                placeholder="e.g. Travel, Office Supplies, Utilities"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
                autoFocus
              />
            </div>
            <p style={{ fontSize: '12px', color: '#64748b', marginTop: '8px' }}>
              This name will appear in the expense recording dropdown.
            </p>
          </div>
        </form>

        <div className={styles['drawer-footer']}>
          <button 
            type="button" 
            className={styles['btn-secondary']} 
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className={styles['btn-primary']} 
            onClick={handleSubmit}
            disabled={isSubmitting || !categoryName.trim()}
          >
            {isSubmitting ? <Loader2 size={18} className={styles['spinner']} /> : <Save size={18} />}
            <span>{isSubmitting ? 'Saving...' : (category ? 'Update Category' : 'Save Category')}</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default AddExpenseCategoryDrawer;
